<template>
  <form v-if="isMonthlyDonation" @submit.prevent="handleSubmit">
    <div class="form-group">
      <label for="firstName">First Name</label>
      <input
        type="text"
        class="form-control"
        id="firstName"
        v-model="formData.firstName"
        :disabled="isSignedIn"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="lastName">Last Name</label>
      <input
        type="text"
        class="form-control"
        id="lastName"
        v-model="formData.lastName"
        :disabled="isSignedIn"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="phoneNumber">Phone Number</label>
      <input
        type="text"
        class="form-control"
        id="phoneNumber"
        v-model="formData.phoneNumber"
        :disabled="isSignedIn"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="email"
        class="form-control"
        id="email"
        v-model="formData.email"
        :disabled="isSignedIn"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="address">Address</label>
      <input
        type="text"
        class="form-control"
        id="address"
        v-model="formData.address"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="address2">Address 2</label>
      <input
        type="text"
        class="form-control"
        id="address2"
        v-model="formData.address2"
      >
    </div>
    <div class="form-group">
      <label for="postalCode">Postal Code</label>
      <input
        type="text"
        class="form-control"
        id="postalCode"
        v-model="formData.postalCode"
        :required="isMonthlyDonation"
      >
    </div>
    <div class="form-group">
      <label for="amount">Amount</label>
      <input
        type="number"
        class="form-control"
        id="amount"
        v-model.number="formData.amount"
        @input="handleAmountUpdate"
        min="10"
        max="10000"
        required
      >
    </div>
    <button type="submit" class="btn btn-primary">Siirry maksupalveluun</button>
  </form>
  <div class="justify-content-center d-flex mt-4" v-else>
    <button :disabled="isButtonDisabled"  class="btn btn-primary" @click="handleSubmit">Siirry maksupalveluun</button>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars
import Axios from 'axios';
import Vue from 'vue';

export default Vue.extend({
  name: 'payment-form-verifone',
  props: {
    amount: {
      type: Number,
      required: true
    },
    campaignId: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: false,
    },
    userFirstName: {
      type: String || null,
    },
    userLastname: {
      type: String,
    },
    userEmail: {
      type: String,
    },
    userPhoneNumber: {
      type: String
    },
    isMonthlyDonation: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      formData: {
        firstName: this.userFirstName || '?',
        lastName: this.userLastname || '?',
        phoneNumber: this.userPhoneNumber || '?',
        email: this.userEmail || '?',
        address: '',
        address2: '',
        postalCode: '',
        amount: this.amount,
        amountIncludingTax: 0,
      },
      isButtonDisabled: false,
      cancelToken: null,
    };
  },
  mounted() {
    this.calculateTax();

  },
  computed: {
    isSignedIn() {
      return (
        this.userFirstName && this.userFirstName.length > 0 &&
        this.userLastname && this.userLastname.length > 0 &&
        this.userEmail && this.userEmail.length > 0
      );
    }
  },
  methods: {
    handleAmountUpdate() {
      this.$emit("update:amount", this.formData.amount);
      this.calculateTax();
    },
    calculateTax() {
      const vat = 0.255; // 25.5% VAT
      this.formData.amountIncludingTax = +(this.formData.amount * (1 + vat)).toFixed(2);
    },
    async handleSubmit() {
      this.isButtonDisabled = true;

      await this.$recaptchaLoaded();
      const recaptchaToken = await this.$recaptcha('submit');

      if (!recaptchaToken) {
        console.error('Recaptcha verification failed');
        this.isButtonDisabled = false;
        return;
      }

      const paymentData = {
        ...this.formData,
        token: recaptchaToken,
        campaignId: this.campaignId,
        userId: this.userId,
        isMonthlyDonation: this.isMonthlyDonation,
      };

      const apiUrl = `${process.env.VUE_APP_FAIR_API}verifonepayment/start-verifone-payment`;

      try {
        const response = await Axios.post(apiUrl, paymentData);
        if (response.data) {
          this.buildAndSubmitForm(response.data);
        } else {
          console.error('Invalid response from payment API');
        }
      } catch (error) {
        console.error('Payment request failed:', error);
      }
    },
    buildAndSubmitForm(fields) {

      const payPageUrl = `${process.env.VUE_APP_VERFIFONE_PAYMENT_START}`;
      const form = document.createElement('form');
      form.setAttribute('method', 'POST');
      form.setAttribute('action', String(payPageUrl));
      form.style.display = 'none';

      for (const [key, value] of Object.entries(fields)) {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', String(value));
        form.appendChild(input);
      }

      document.body.appendChild(form);

      this.isRedirecting = true;

      form.submit();
    },
  },
});
</script>

<style scoped>
.modal-dialog {
  max-width: 600px;
}
</style>